import {createProjectModel} from 'company-management/utils/project-model'
import {init, login} from '../services/auth'
import baseModal from './base'

let isLogoutClick = false

function setIsLogoutClick(flag) {
    isLogoutClick = !!flag
}

const model = createProjectModel({
    projectNamespace: 'auth',

    state: {
        initData: {},
    },

    effects: {
        *init({payload}, {call, put}) {
            const res = yield call(init, payload)
            yield put({
                type: 'immerSet',
                payload: {
                    initData: res?.data,
                },
            })
            return res
        },
        *login({payload}, {call, put}) {
            const res = yield call(login, payload)
            const accessToken = res?.data?.access_token
            yield put({
                type: `${baseModal.namespace}/immerSetAccessToken`,
                payload: {
                    accessToken,
                },
            })
        },
        *logout(_, {put}) {
            if (isLogoutClick) {
                return
            }

            setIsLogoutClick(true)

            yield put({
                type: `${baseModal.namespace}/immerRemoveAccessToken`,
            })

            setIsLogoutClick(false)
        },
    },

    reducers: {},
})

export default model
